<template>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 12.5H18.6V5H11V12.5V12.5ZM22.4 35H30V27.5H22.4V35V35ZM11 35H18.6V27.5H11V35V35ZM11 23.75H18.6V16.25H11V23.75V23.75ZM22.4 23.75H30V16.25H22.4V23.75V23.75ZM22.4 12.5H30V5H22.4V12.5V12.5Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "CalendarIcon"
};
</script>
